<template>
  <div class="verify-address m-auto">
    <StepHeader
      :title="title"
      :theme="theme"
    />
    <StepContent
      :theme="theme"
      width="max-w-600"
    >
      <DocumentUpload
        :upload-buttons="uploadButtons"
        :docs-stand-alone="docsStandAlone"
        :theme="theme"
      >
        <template #step-summary>
          <p class="text-center text-base">
            Please upload an image of a recent bill or any piece of mail with your name, address, and a date within the last two months. Most commonly this is a phone, internet or gas bill.
          </p>
        </template>
      </DocumentUpload>
    </StepContent>
    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="handleContinue"
      >
        Continue
      </AppButton>

      <StepSkip
        verification-step="address"
        :theme="theme"
        @skip="handleSkip"
      />
    </StepFooter>
  </div>
</template>

<script>
import StepHeader from '@/components/common/step-layout/StepHeader'
import StepContent from '@/components/common/step-layout/StepContent'
import DocumentUpload from '@/components/common/document-upload/DocumentUpload'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepSkip from '@/components/common/step-layout/StepSkip'
import AppButton from '@/components/common/buttons/AppButton'
import navigation from '@/mixins/navigation'
import submitLoans from '@/mixins/submit/submit-loans'

export default {
  name: 'VerifyAddress',

  // Components
  components: {
    StepHeader,
    StepContent,
    DocumentUpload,
    StepSkip,
    StepFooter,
    AppButton
  },

  // Mixins
  mixins: [
    navigation,
    submitLoans
  ],

  // Props
  props: {
    docsStandAlone: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'green'
    }
  },

  // Computed
  computed: {
    title () {
      return 'Verify Your Address'
    },

    addressFileError () {
      return this.$store.state.validations.addressFileError
    },

    returningCustomer () {
      return this.$store.state.returningCustomer.is_in_progress
    },

    dataLayerObject () {
      const eventName = this.returningCustomer ? 'spring_ploan_returning_customer_address_step_completed' : 'spring_ploan_address_step_completed'
      return {
        event: eventName
      }
    },

    datalayerSkip () {
      return {
        event: 'spring_ploan_verifyaddress_skip'
      }
    },

    dataLayerUpload () {
      const eventName = this.returningCustomer ? 'spring_ploan_returning_customer_address_document_upload' : 'spring_ploan_address_document_upload'
      return {
        event: eventName
      }
    },

    uploadButtons () {
      return [
        {
          documentType: 'POA',
          title: 'Upload Proof of Address',
          value: this.file,
          vuexAction: 'setPOA',
          vuexActionFile: 'setPOAFile',
          required: !this.$store.state.documents.poa,
          dataLayerEvent: this.dataLayerUpload,
          error: this.addressFileError
        }
      ]
    },

    file () {
      return this.$store.state.documents.poaFile
    }
  },

  // Watch
  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    },

    $_navigation_triggerSkip: function (val) {
      if (val) this.handleSkip()
      this.$store.dispatch('setTriggerSkipStep', false)
    }
  },

  // Methods
  methods: {
    handleSkip () {
      this.$store.dispatch('setSkippedStep', true)
      this.$_navigation_handleNext(this.datalayerSkip, true)
    },

    async handleContinue () {
      const isValid = await this.$_navigation_validateStep()
      if (!isValid) return new Error('Validation failed.')
      await this.$_loans_submitLeadIfReady(false, false, this.dataLayerObject)
    }
  }
}
</script>
